<script>
	import { getClient, query } from 'svelte-apollo';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import moment from 'moment';
	import Button, { Label } from '@smui/button/styled';
	import { Link } from 'svelte-routing';
	import { APP_PATHS } from '../../constants';
	import { onMount } from 'svelte';
	import AppContainer from '../../components/AppContainer.svelte';
	import Text from '../../components/Text.svelte';
	import { getUsersQuery } from '../../graphql/queries/users';
	import UserActionsCell from '../../components/Users/UserActionsCell.svelte';
	import SimpleTable from '../../components/SimpleTable.svelte';

	const client = getClient();

	const getUsers = query(client, { query: getUsersQuery });

	const columns = [
		{
			key: 'email',
			title: 'E-mail',
			value: (v) => v.email,
			sortable: true,
			searchValue: (v) => v.email
		},
		{
			key: 'logged',
			title: 'Last login',
			value: (v) => v.lastLoggedIn,
			renderValue: (v) =>
				v.lastLoggedIn !== null
					? moment(v.lastLoggedIn).format('MM/DD/YYYY')
					: '<span style="color: red">never</span>'
		},
		{
			key: 'role',
			title: 'Role',
			value: (v) => v.role,
			filterOptions: ['USER', 'ADMIN', 'SUPERADMIN'],
			sortable: true,
			renderComponent: UserActionsCell
		}
	];

	function refresh() {
		getUsers.refetch();
	}

	onMount(() => {
		refresh();
	});
</script>

<AppContainer>
	<Text gutter type="headline3">User management</Text>

	<Link to={APP_PATHS.USER_MANAGEMENT_ADD}>
		<Button variant="raised" class="add-button">
			<Label>Add new user</Label>
		</Button>
	</Link>

	<hr class="divider" />

	{#await $getUsers}
		<LoadingOverlay title="Loading..." spinner />
	{:then data}
		<SimpleTable rows={data.data.users} {columns} sortBy="email" on:refresh={refresh} />
	{:catch e}
		{e}
	{/await}
</AppContainer>

<style>
	:global(.add-button) {
		margin-top: 15px;
		margin-bottom: 30px;
	}

	.divider {
		margin-bottom: 20px;
	}
</style>
